import { captureException } from '@sentry/react'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import {
	type HttpGetPhotosetImagesOptions,
	HttpGetPhotosetImagesResponse,
	httpGetPhotosetImages
} from '@/features/photoset/http/photoset.http'
import { parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetPhotosetImages = (
	promiseArgs: HttpGetPhotosetImagesOptions,
	options?: Omit<
		UseQueryOptions<HttpGetPhotosetImagesResponse>,
		'queryFn' | 'queryKey'
	>
) =>
	useQuery({
		...options,
		queryKey: [QUERY_KEYS.IMAGES, promiseArgs],
		queryFn: () =>
			parseAxiosPromise({
				axiosPromise: httpGetPhotosetImages(promiseArgs),
				responseShape: HttpGetPhotosetImagesResponse,
				onZodError: captureException
			})
	})
